import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export default function locationsRoutes($stateProvider: StateProvider) {
    let locationsModule: { default: any; };
    $stateProvider
        .state({
            name: 'locations',
            url: '/locations',
            component:  KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => locationsModule.default,
            },
            lazyLoad: async () => {
                locationsModule = await import(/* webpackChunkName: "locations" */ './KpLocations.svelte');
                return null;
            }
        });
}